module.exports = __webpack_public_path__ + "img/eagle.ace1512.svg";